import {
    COMPLETE_WHEELS_SET_CATEGORY
} from '../Actions/CompleteWheels.action'

const defaultState = {
    category: "",
    includeSeasonFilter: false,
    missingProductsText: ""
}

export const completeWheels = (state = defaultState, action) => {
    const { type, payload } = action
    switch (type) {
        case COMPLETE_WHEELS_SET_CATEGORY:
            return {
                ...state,
                ...payload,
                
            }
        default:
            return state
    }

}